import axios from "axios";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";
import { formatDate } from "../../helpers/DateConversion";

export default function ViewOrderType() {
  const location = useLocation();
  const data = location.state.data;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const markAsDelivered = async () => {
    try {
      setLoading(true);
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      const formdata = new FormData();
      formdata.append("orderId", data._id);
      formdata.append("status", "Delivered");

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/order/update-status`,
        formdata,
        { headers }
      );

      if (response.data.statusCode === 200) {
        toast.success(response?.data?.message);
        navigate(-1);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update status. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div>
      <ToastContainer />
      <Layout>
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">View Order</h2>
            {data.status === "Pending" && (
              <button
                className="border py-2 px-2 rounded-md text-sm !outline-none"
                onClick={markAsDelivered}
              >
                {loading ? "Updating Status..." : "Mark As Delivered"}
              </button>
            )}
          </div>

          <div className="mt-10">
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Order Id</h6>
                <p className="mt-1">{data.orderId}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Product Name</h6>
                <p className="mt-1">{data?.productId?.name || "N/A"}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Quantity</h6>
                <p className="mt-1">{data.quantity}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Amount</h6>
                <p className="mt-1">{data.amount}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Is Emergency</h6>
                <p className="mt-1">{data.isEmergency ? "Yes" : "No"}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Payment Method</h6>
                <p className="mt-1">{data.paymentMethod}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">User Email</h6>
                <p className="mt-1">{data?.userId?.email || "N/A"}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Status</h6>
                <p className="mt-1">{data.status}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Total Amount</h6>
                <p className="mt-1">{data.totalAmount}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Created At</h6>
                <p className="mt-1">{formatDate(data.createdAt)}</p>
              </div>
            </div>

            {/* Optional: Display Address if populated */}
            {data?.addressId?.fullAddress && (
              <>
                <hr />
                <div className="flex my-6">
                  <div className="w-full">
                    <h6 className="text-sm font-medium">Address</h6>
                    <p className="mt-1">
                      {`${data.addressId.fullAddress}, ${data.addressId.city}, ${data.addressId.state}, ${data.addressId.pincode}`}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </Layout>
    </div>
  );
}
